import React from "react";
import Btn from "parts/Btn";

import HeroImage from "assets/images/hero.png";

export default function Hero({ emailMe }) {
    return (
        <div className="mt-10 flex flex-col md:flex-row justify-between items-center mb-5 md:mb-0">
            <div className="w-full">
                <div className="text-xl md:text-2xl font-medium mb-12">
                    Hey, I’m Hariyanto 👋
                </div>
                <div className="text-4xl md:text-6xl font-semibold mb-10">
                    Front-End Web Developer
                </div>
                <div className="w-full md:w-3/4 text-lg text-gray-500 mb-12">
                    A Front-End Web & Mobile & Developer, i’m love working using
                    javascript libraries / framework. especially React.js
                </div>

                <div className="flex flex-row items-center gap-2 mb-14 justify-between md:justify-start">
                    <Btn handleClick={emailMe}>Lets Talk</Btn>
                    <div className="btn-text w-max">
                        <span className="inline align-middle mr-2">
                            My Works
                        </span>
                        {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4 inline align-middle"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                            />
                        </svg> */}
                    </div>
                </div>
            </div>
            <div className="w-full">
                <img className="w-full" src={HeroImage} alt={HeroImage} />
            </div>
        </div>
    );
}
